import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import MultiSelect from '../../../internal/MultiSelect'
import MultiSelectTwoStep from '../../../internal/MultiSelectTwoStep'

import { getText } from '../../../internal/TextLabels'

const NewsFormStore = ({
  fieldName,
  fieldCaption,
  newsStores,
  stores,
  representatives,
  onChange,
  getStores,
}) => {
  const [selectedStores, setSelectedStores] = useState([...newsStores])

  const [storeIds, setStoreIds] = useState([])
  const [storeNames, setStoreNames] = useState([])
  const [representativeIds, setRepresentativeIds] = useState([])
  const [representativeNames, setRepresentativeNames] = useState([])
  const [newsStoreIds, setNewsStoreIds] = useState([])
  const [newsStoreNames, setNewsStoreNames] = useState([])

  const splitIdsAndNames = (list, idsFunc, namesFunc) => {
    const ids = []
    const names = []
    list.forEach(s => {
      ids.push(s.id)
      names.push(s.name)
    })
    idsFunc(ids)
    namesFunc(names)
  }
  useEffect(
    () => splitIdsAndNames(stores, setStoreIds, setStoreNames),
    [stores],
  )

  useEffect(
    () =>
      splitIdsAndNames(
        representatives,
        setRepresentativeIds,
        setRepresentativeNames,
      ),
    [representatives],
  )

  useEffect(
    () => splitIdsAndNames(newsStores, setNewsStoreIds, setNewsStoreNames),
    [newsStores],
  )
  const onSelect = values => {
    const addSelectedStores = values
      .filter(id => selectedStores.every(s => s.id !== id))
      .map(id => {
        const store = stores.find(s => s.id === id)
        return { id, name: store.tradeName }
      })
    const newSelectedStores = [
      ...selectedStores.filter(store => values.includes(store.id)),
      ...addSelectedStores,
    ]
    setSelectedStores(newSelectedStores)
    onChange(newSelectedStores)
  }

  const step1 = {
    fieldCaption: getText('news.add.recipientSection.selectRepresentative'),
    values: representativeIds,
    names: representativeNames,
  }

  if (step1.values && step1.values.length === 1) {
    return (
      <MultiSelect
        fieldName={fieldName}
        fieldCaption={fieldCaption}
        values={storeIds}
        defaultValues={newsStoreIds}
        multiple={stores.length > 1}
        names={storeNames}
        addText={getText('news.add.recipientSection.addStore')}
        onChange={values => onSelect(values)}
        round
        hideButton
      />
    )
  }

  const target = {
    fieldCaption,
    names: storeNames,
    values: storeIds,
    defaultNames: newsStoreNames,
    defaultValues: newsStoreIds,
  }
  return (
    <MultiSelectTwoStep
      fieldName={fieldName}
      step1={step1}
      target={target}
      multiple={stores.length > 1}
      addText={getText('news.add.recipientSection.addStore')}
      onStep1Change={representativeId => getStores(representativeId)}
      onChange={values => onSelect(values)}
      round
      hideButton
    />
  )
}

NewsFormStore.propTypes = {
  fieldName: PropTypes.string.isRequired,
  fieldCaption: PropTypes.string.isRequired,
  newsStores: PropTypes.array.isRequired,
  stores: PropTypes.array.isRequired,
  representatives: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  getStores: PropTypes.func.isRequired,
}

export default NewsFormStore
